import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { colors, type, spacing, radius } from "@/theme";
import { useAuth } from "@/context/AuthContext";

export default function StaffLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => { document.title = "Accesso staff | Tavoline"; }, []);

  const onLogin = async () => {
    setBusy(true); setError(null);
    try {
      const u = await login(email.trim(), password);
      navigate(u.role === "superadmin" ? "/superadmin" : "/staff/kds", { replace: true });
    } catch (e) { setError(e.message); } finally { setBusy(false); }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", backgroundImage: `linear-gradient(rgba(26,24,21,0.4), rgba(26,24,21,0.9)), url(https://images.pexels.com/photos/827528/pexels-photo-827528.jpeg?auto=compress&cs=tinysrgb&w=1200)`, backgroundSize: "cover", backgroundPosition: "center" }}>
      <div style={{ padding: spacing.lg, maxWidth: 480, width: "100%", margin: "0 auto", display: "flex", flexDirection: "column", flex: 1 }}>
        <button data-testid="back-button" onClick={() => navigate("/accedi")} style={{ background: "none", border: "none", display: "flex", padding: `${spacing.lg}px 0`, alignSelf: "flex-start" }}><ChevronLeft size={26} color="#fff" /></button>
        <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}>
          <div style={{ ...type.serif, fontSize: 36, color: "#fff" }}>Accesso staff</div>
          <div style={{ ...type.sans, fontSize: 16, color: "rgba(255,255,255,0.85)", marginTop: spacing.xs }}>Cucina, sala e cassa.</div>
          <div style={{ marginTop: spacing.xl, display: "flex", flexDirection: "column", gap: spacing.md }}>
            <input data-testid="email-input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" autoCapitalize="none" type="email" style={input} />
            <input data-testid="password-input" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" type="password" onKeyDown={(e) => e.key === "Enter" && onLogin()} style={input} />
            {error ? <div style={{ ...type.sansMedium, fontSize: 14, color: "#FFD3CC" }}>{error}</div> : null}
            <button data-testid="login-button" onClick={onLogin} disabled={busy} style={{ background: colors.accent, height: 56, border: "none", borderRadius: radius.md, color: colors.onAccent, ...type.sansSemi, fontSize: 17, marginTop: spacing.sm }}>{busy ? "…" : "Entra"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

const input = { background: colors.surface, borderRadius: radius.md, height: 56, padding: `0 ${spacing.md}px`, border: "none", ...type.sans, fontSize: 16, color: colors.ink };
